<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <div class="fl w-400">
        <el-input placeholder="请输入企业信息、申请人信息" clearable v-model="formSearch.name">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
      <el-select v-model="formSearch.status" size="small" placeholder="归档状态" v-on:change="search()" class="el-input-search m-l-30">
        <el-option label="待审核" :value="0"></el-option>
        <el-option label="通过" :value="1"></el-option>
        <el-option label="驳回" :value="-1"></el-option>
      </el-select>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="申请人"
      width="100"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="username"
      label="申请人电话"
      width="150"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_company_name"
      label="企业全称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_discern_code"
      label="纳税人识别号"
      width="200">
      </el-table-column>
      <el-table-column
      prop="rise_company_addr"
      label="公司注册地址"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_company_phone"
      label="公司联系电话"
       width="130"
       :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_bank_name"
      label="开户行名称"
      width="200"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="rise_bank_code"
      label="开户银行账号"
      width="180"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" class="success_status">通过</span>
            <span v-else-if = "scope.row.status ==0" class="goon_status">待审核</span>
            <span v-else-if = "scope.row.status ==-1" class="error_status">驳回</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      fixed="right"
      width="100">
        <template scope="scope">
          <div>
            <span>
              <el-button v-if="scope.row.status ==0" size="small" type="primary" @click="shenhe(scope.row)">审核</el-button>
              <el-button v-if="scope.row.status !=0" size="small" type="primary" @click="shenhe(scope.row)">查看</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'company'"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="审核企业申请" :visible.sync="company_detail_open" custom-class="w-800 h-800">
      <el-form ref="form" :model="company_detail" label-width="250px">
        <el-form-item label="企业全称：">
          {{company_detail.rise_company_name}}
        </el-form-item>
        <el-form-item label="纳税人识别号：">
          {{company_detail.rise_discern_code}}
        </el-form-item>
        <el-form-item label="企业注册地址：">
          {{company_detail.rise_company_addr}}
        </el-form-item>
        <el-form-item label="企业联系电话：">
          {{company_detail.rise_company_phone}}
        </el-form-item>
        <el-form-item label="开户行名称：">
          {{company_detail.rise_bank_name}}
        </el-form-item>
        <el-form-item label="开户银行账号：">
          {{company_detail.rise_bank_code}}
        </el-form-item>
        <el-form-item label="纳税人性质：" class="w-600">
          <span v-if="company_detail.vat_type==1">小规模纳税人</span>
          <span v-if="company_detail.vat_type==2">一般纳税人</span>
        </el-form-item>
        <el-form-item v-if="company_detail.status==0" label="允许使用模块">
          <el-checkbox-group v-model="mokuai">
            <el-checkbox v-for="item in mokuai_list" :label="item.id">{{item.menu_name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="" v-if="company_detail.status==0" class="w-700">
          <el-button size="small" type="success" class="fr m-l-30" @click="save_shenqing(1)">通过</el-button>
          <el-button size="small" type="danger" class="fr" @click="save_shenqing(-1)">驳回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'
  import { sendSock, createWebSocket, closeSock } from "../../../../assets/js/socket"

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        formSearch: {
          name: '',
          status: 0,
        },
        company_detail: [],
        company_detail_open: false,
        mokuai_list: [],
        mokuai: [2, 3, 5, 6, 7, 8],
        multipleSelection: [],
        limit: 15,
        chat_token: '',
        notice_form: {
          name: '',
          value: '',
          user_id: '',
          is_urgent: true
        }
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
        this.getAllUsers()
      },
      selectItem(val) {
        console.log(val)
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      save_shenqing(status) {
        var tip = '通过'
        if (status == -1) {
          tip = '驳回'
        }
        this.$prompt('确认 ' + tip + ' 该企业申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          _g.openGlobalLoading()
          const data = {
            params: {
              mokuai: this.mokuai,
              status: status,
              id: this.company_detail.id
            }
          }
          this.apiPost('admin/company/company_place_set', data).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', tip + '成功')
              this.notice_form.name = '企业申请' + tip + '通知'
              this.notice_form.user_id = this.company_detail.uid
              if (tip == '通过') {
                this.notice_form.value = '你的企业申请已通过，点击页面左上角的切换企业即可查看'
              } else {
                this.notice_form.value = '你的企业申请被驳回，驳回理由是：' + value
              }
              this.send_notice()
              setTimeout(() => {
                this.company_detail_open = false
                this.getAllUsers()
              }, 1000)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      get_mokuai() {
        this.apiGet('admin/base/mokuai_list').then((res) => {
          this.handelResponse(res, (data) => {
            this.mokuai_list = data.list
            this.mokuai = data.check_list
          })
        })
      },
      shenhe(row) {
        this.company_detail = row
        this.company_detail_open = true
        this.get_mokuai()
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.formSearch,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/company/company_place', data).then((res) => {
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      initWebSocket(e) {
        createWebSocket(this.global_callback);
      },
      global_callback(msg) {
        
      },
      send_notice() {
        if (!this.notice_form.name) {
          _g.toastMsg('error', '请输入通知标题')
          return
        }
        if (!this.notice_form.value) {
          _g.toastMsg('error', '请输入通知内容')
          return
        }
        const data = {
          type: 'notice_send',
          token: this.chat_token,
          content: this.notice_form,
        }
        var post_data = JSON.stringify(data)
        console.log(post_data)
        sendSock(post_data)
        _g.toastMsg('success', '发送审核通知成功')
        this.notice_form.name = ''
        this.notice_form.value = ''
        this.notice_form.user_id = ''
        this.notice_form.is_urgent = true
        return true
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
        let user = Lockr.get('userInfo')
        this.chat_token = user.chat_token
        if (this.chat_token) {
          this.initWebSocket()
        }
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('company-save')
      },
      editShow() {
        return _g.getHasRule('company-update')
      },
      deleteShow() {
        return _g.getHasRule('company-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?418010f7